<template>
  <span class="groupRuleEdit">
    <template v-if="editing">
      <span class="humanReadableRuleEditor">
        <template v-if="RelationIsSpecial(rule.relation)">
          <template v-if="rule.relation === 'total_price'">
            <span>
              Het <strong>totaalbedrag</strong> van de order

              <b-form-select
                v-model="rule.operator"
                :options="GetAvailableOperators(rule.relation)"
                class="d-inline-block mx-2"
                size="sm"
                style="width: 320px"
              />

              <b-form-input
                v-model="rule.value"
                class="d-inline-block mx-2"
                size="sm"
                style="width: 64px"
                type="number"
              />
              euro
            </span>
          </template>

          <template v-else-if="rule.relation === 'sales_order_lines'">
            <span>Er is een orderregel met een <strong>aantal dat
              
              <b-form-select
                v-model="rule.operator"
                :options="GetAvailableOperators(rule.relation)"
                class="d-inline-block mx-2"
                size="sm"
                style="width: 320px"
                type="number" />

                <b-form-input
                  v-model="rule.value"
                  class="d-inline-block mx-2"
                  size="sm"
                  style="width: 64px"
                  type="number"
                  />

              </strong></span>
          </template>

          <template v-else-if="rule.relation === 'hours_between_same_order'">
            <span>
              Er zijn
              <b-form-input
                v-model="rule.value"
                class="d-inline-block mx-2"
                size="sm"
                style="width: 64px"
                type="number"
              />
              uur of minder tussen twee bestellingen van dezelfde klant</span
            >
          </template>

          <template v-else>
            <!-- Just show the rule when there is a special relation that is not yet supported in the editor -->
            <GroupRule :rule="rule" />
          </template>
        </template>

        <template v-else>
          uit

          <b-form-select
            v-model="rule.relation"
            :options="Relations"
            class="d-inline-block mx-2"
            size="sm"
            style="width: 200px"
          />

          de waarde van

          <b-form-select
            v-model="rule.field"
            :options="GetAvailableFields(rule.relation)"
            class="d-inline-block mx-2"
            size="sm"
            style="width: 200px"
          />

          <b-form-select
            v-model="rule.operator"
            :options="GetAvailableOperators(rule.relation)"
            class="d-inline-block mx-2"
            size="sm"
            style="width: 200px"
          />

          <b-form-input
            v-model="rule.value"
            class="d-inline-block mx-2"
            size="sm"
            style="width: 200px"
          />
        </template>
      </span>
    </template>

    <template v-else>
      <GroupRule :rule="rule" />
    </template>
  </span>
</template>

<script>
import {
  Relations,
  Fields,
  Operators,
  RelationIsSpecial,
  GetAvailableFields,
  GetAvailableOperators,
} from "@/data/holdRules";
import { mapObjectKey } from "@/helpers/mappings";
import GroupRule from "./GroupRule.vue";

export default {
  components: { GroupRule },
  name: "GroupRuleEdit",
  props: {
    rule: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      Relations,
      Fields,
      Operators,
    };
  },
  methods: {
    mapObjectKey,
    RelationIsSpecial,
    GetAvailableFields,
    GetAvailableOperators,
  },
};
</script>